import { useCallback, useEffect, useRef, useState } from 'react';

import { isLlmPrivateBlock, subscribeLlmPrivate, toggleLlmPrivate } from './llm-private-api';

export function useLlmPrivateBlock(blockId: string | null | undefined): {
  isPrivate: boolean;
  toggling: boolean;
  toggle: () => Promise<void>;
} {
  const [isPrivate, setIsPrivate] = useState(() =>
    blockId ? isLlmPrivateBlock(blockId) : false,
  );
  const [toggling, setToggling] = useState(false);
  const busy = useRef(false);

  useEffect(() => {
    if (!blockId) {
      setIsPrivate(false);
      return;
    }
    setIsPrivate(isLlmPrivateBlock(blockId));
    return subscribeLlmPrivate(() => {
      setIsPrivate(isLlmPrivateBlock(blockId));
    });
  }, [blockId]);

  const toggle = useCallback(async () => {
    if (!blockId || busy.current) {
      return;
    }
    busy.current = true;
    setToggling(true);
    try {
      await toggleLlmPrivate(blockId);
    } finally {
      busy.current = false;
      setToggling(false);
    }
  }, [blockId]);

  return { isPrivate, toggling, toggle };
}
